import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TvActionDatepickerComponent } from "./components/tv-action-datepicker/tv-action-datepicker.component";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatNativeDateModule, MatOptionModule } from "@angular/material/core";
import { ReactiveFormsModule } from "@angular/forms";
import { AgGridModule } from 'ag-grid-angular';

import { TvActionInputComponent } from "./components/tv-action-input/tv-action-input.component";
import { TvActionSelectComponent } from "./components/tv-action-select/tv-action-select.component";
import { TvActionListComponent } from "./components/tv-action-list/tv-action-list.component";
import { MatListModule } from "@angular/material/list";
import { MatSelectModule } from "@angular/material/select";
import { TvActionInputGroupComponent } from "./components/tv-action-input-group/tv-action-input-group.component";
import { UiGridComponent } from "./legacy-components/ui-grid/ui-grid.component";
import { NotificationComponent } from "./components/notification/notification.component";
import { NotificationService } from "./components/notification/notification.service";
import { UibModalServiceProvider } from "./legacy-services/modal/UibModalProvider";
import { MatExpansionModule } from "@angular/material/expansion";
import { TvActionGridComponent } from './components/tv-action-grid/tv-action-grid.component';
import { TvActionChipsComponent } from "@tva/ng-migration/uicomponents/components";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatChipsModule } from "@angular/material/chips";
import { MatIconModule } from "@angular/material/icon";
import { TvActionInputErrorComponent } from './components/tv-action-input-error/tv-action-input-error.component';
import { TvActionErrorComponent } from './components/tv-action-error/tv-action-error.component';
import './uicomponents.downgrades';
import { TvActionRadioComponent } from './components/tva-radio/tva-radio.component';
import { MatRadioModule } from "@angular/material/radio";

@NgModule({
  declarations: [
    TvActionDatepickerComponent,
    TvActionInputComponent,
    TvActionSelectComponent,
    TvActionListComponent,
    TvActionInputGroupComponent,
    TvActionGridComponent,
    TvActionChipsComponent,
    UiGridComponent,
    NotificationComponent,
    TvActionInputErrorComponent,
    TvActionErrorComponent,
    TvActionRadioComponent,
  ],
  providers: [NotificationService, UibModalServiceProvider],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatListModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    MatOptionModule,
    MatSelectModule,
    MatExpansionModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatIconModule,
    MatRadioModule,
    AgGridModule.withComponents([])
  ],
  exports: [
    TvActionDatepickerComponent,
    TvActionInputComponent,
    TvActionListComponent,
    TvActionSelectComponent,
    TvActionInputGroupComponent,
    TvActionChipsComponent,
    TvActionRadioComponent,
    UiGridComponent,
    NotificationComponent,
    TvActionGridComponent,
    TvActionInputErrorComponent,
    TvActionErrorComponent,
  ],
})
export class UIComponentsModule { }
